import React, { useState, useEffect, useMemo } from "react"
import { Button, Spinner, Table } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { deleteLeadAction, fetchLeadsAction } from "../../pages/lead/leadAction"
import { NoData } from "../no-data/NoData"
import "./leadTable.css"
import { AiFillClockCircle } from "react-icons/ai"

export const LeadTable = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.user)
  const [lds, setLds] = useState([])
  const { isLoading, leads } = useSelector((state) => state.studentLead)

  const params = useMemo(() => {
    const p = new URLSearchParams()
    p.set("branch", user?.branch)
    return p
  }, [user?.branch])

  useEffect(() => {
    //fetch all teh leads

    dispatch(fetchLeadsAction(params.toString()))
  }, [dispatch, params])

  useEffect(() => {
    setLds(leads)
  }, [leads])

  const handleOnDelete = (_id) => {
    window.confirm("Are you sure you want to delete this lead?") &&
      dispatch(deleteLeadAction({ _id, par: params.toString() }))
  }

  if (isLoading) {
    return <Spinner animation="border" variant="primary" />
  }
  if (!lds?.length) {
    return <NoData />
  }

  // today
  const today = new Date()

  return (
    <div>
      <div className="mb-2 fw-bold">{lds.length} leads found!</div>
      <Table striped bordered responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Status</th>
            <th>Next Follow-up</th>
            <th>Location</th>
            <th>Stage</th>
            <th>Agent Name</th>
            <th>Details</th>
            {user?.role === "admin" && <th>Delete</th>}
          </tr>
        </thead>
        <tbody>
          {lds.map((lead, index) => (
            <tr key={lead._id}>
              <td>{index + 1}</td>
              <td>{`${lead.fName} ${lead.lName}`}</td>
              <td>{lead.progress}</td>
              {lead?.reminder?.date ? (
                <>
                  <td>
                    <div style={{ width: "max-content" }}>
                      {(new Date(lead?.reminder?.date) - today) /
                        (1000 * 3600 * 24) >
                        1 &&
                        (new Date(lead?.reminder?.date) - today) /
                          (1000 * 3600 * 24) <=
                          2 && (
                          <div
                            className="upcoming"
                            data-balloon-pos="right"
                            aria-label={lead?.reminder?.title}
                          >
                            <AiFillClockCircle size={18} color="#2376EE" />
                            Upcoming
                          </div>
                        )}

                      {(new Date(lead?.reminder?.date) - today) /
                        (1000 * 3600 * 24) <=
                        1 &&
                        (new Date(lead?.reminder?.date) - today) /
                          (1000 * 3600 * 24) >
                          0 && (
                          <div
                            className="upcoming urgent"
                            data-balloon-pos="right"
                            aria-label={lead?.reminder?.title}
                          >
                            <AiFillClockCircle size={18} color="#ee2323" />
                            Upcoming
                          </div>
                        )}

                      {(new Date(lead?.reminder?.date) - today) /
                        (1000 * 3600 * 24) <=
                        0 && (
                        <div
                          className="upcoming urgent"
                          data-balloon-pos="right"
                          aria-label={lead?.reminder?.title}
                        >
                          <AiFillClockCircle size={18} color="#ee2323" />
                          Overdue
                        </div>
                      )}

                      {(new Date(lead?.reminder?.date) - today) /
                        (1000 * 3600 * 24) >
                        2 && (
                        <div
                          data-balloon-pos="right"
                          aria-label={lead?.reminder?.title}
                        >
                          {new Date(lead?.reminder?.date).toLocaleDateString(
                            "en-AU"
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                </>
              ) : (
                <td>N/A</td>
              )}

              <td className="text-capitalize">{lead.location}</td>
              <td>{lead?.stage?.stageId ? lead?.stage?.stageTitle : "Raw"}</td>
              <td>{lead.agent?.name ? lead.agent?.name : "-"}</td>
              <td>
                <Link to={`/lead/${lead._id}`}>
                  {" "}
                  <Button variant="success">Info</Button>
                </Link>
              </td>
              {user?.role === "admin" && (
                <td>
                  <Button
                    variant="danger"
                    onClick={() => handleOnDelete(lead._id)}
                  >
                    Delete
                  </Button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}
